/* ALOHA : les rubriques du pied de page deviennent des accordeons sur
   telephone. Empilees, les 16 liens faisaient plus de deux ecrans.
   Repliees, les trois rubriques tiennent en trois lignes.
   Sur desktop le script ne fait rien : les colonnes restent ouvertes. */

(function () {
  var MOBILE = window.matchMedia('(max-width: 750px)');

  function init() {
    var blocs = document.querySelectorAll('.footer__content .menu-block');

    Array.prototype.forEach.call(blocs, function (bloc) {
      var titre = bloc.querySelector('.text-block');
      var liste = bloc.querySelector('.menu-block__list');

      if (!titre || !liste) return;

      if (!bloc.getAttribute('data-aloha-accordeon')) {
        bloc.setAttribute('data-aloha-accordeon', 'oui');
        titre.classList.add('aloha-footer__toggle');
        titre.setAttribute('role', 'button');
        titre.setAttribute('tabindex', '0');

        var bascule = function () {
          if (!MOBILE.matches) return;
          var ouvert = bloc.classList.toggle('aloha-footer__ouvert');
          titre.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
        };

        /* toute la ligne est tappable, pas seulement la largeur du mot :
           on ignore les clics qui visent un lien de la liste */
        bloc.addEventListener('click', function (e) {
          if (e.target.closest('.menu-block__list')) return;
          bascule();
        });
        titre.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            bascule();
          }
        });
      }

      /* replie par defaut sur telephone, toujours ouvert ailleurs */
      if (MOBILE.matches) {
        bloc.classList.remove('aloha-footer__ouvert');
        titre.setAttribute('aria-expanded', 'false');
      } else {
        titre.removeAttribute('aria-expanded');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (MOBILE.addEventListener) {
    MOBILE.addEventListener('change', init);
  }
})();
